class SeletRange extends DummyElement {
  #input;
  #dropdown;

  constructor() {
    super();

    this.setAttribute("data-property", this.label);

    const shadow = this.attachShadow({ mode: "open" });
    const container = document.createElement("div");
    container.classList.add("w-full", "my-15");
    const label = document.createElement("label");
    const span = document.createElement("span");
    span.innerText = this.label;
    const input = document.createElement("input");
    this.#input = input;
    input.classList.add("flex", "flex-wrap");

    const dropdown = document.createElement("input-dropdown");
    this.#dropdown = dropdown;
    this.#dropdown.setAttribute("postfix", this.postfix);
    this.#dropdown.setAttribute("overlay", "");
    this.#dropdown.addEventListener(
      "change",
      this.#handleDropdownChange.bind(this)
    );
    container.appendChild(dropdown);

    label.appendChild(span);
    label.appendChild(input);
    container.appendChild(label);
    shadow.appendChild(container);

    const style = document.createElement("style");
    style.textContent = this.#generateStyle();

    shadow.appendChild(style);

    this.#input.addEventListener("focus", this.#handleInputFocus.bind(this));
    this.#input.addEventListener("blur", this.#handleInputBlur.bind(this));

    if (this.defaultValue) {
      this.value = this.defaultValue;
      this.#input.value = this.value;
    }
  }

  connectedCallback() {
    if (this.list) {
      this.options = this.list
        .map((d) => parseFloat(d[this.name]))
        .filter((d, i, a) => a.findIndex((item) => item === d) === i);
    }
    this.#dropdown?.setAttribute("options", this.options);
    PriceRenderer.registerSymbol(this.name, this.#dropdown.options[0]);
  }

  disconnectedCallback() {
    this.#input.removeEventListener("focus", this.#handleInputFocus);
    this.#input.removeEventListener("blur", this.#handleInputBlur);
  }

  get label() {
    return this.getAttribute("label");
  }

  get options() {
    return this.getAttribute("options");
  }

  set options(options) {
    this.setAttribute("options", options);
  }

  get postfix() {
    return this.getAttribute("postfix");
  }

  get name() {
    return this.getAttribute("name");
  }

  get list() {
    return window[this.getAttribute("list")];
  }

  get value() {
    return this.#input.value;
  }

  set value(newValue) {
    let currentValue = newValue.replace(this.postfix, "") || 0;
    currentValue = isNaN(currentValue) ? 0 : parseFloat(currentValue);
    if (JSON.parse(`[${this.options}]`).includes(currentValue)) {
      this.#input.value = currentValue + this.postfix;
      PriceRenderer.modifySymbol(this.name, currentValue);
    }
  }

  #handleInputFocus() {
    this.#dropdown?.setAttribute("open", "");

    if (this.list) {
      const keys = PriceRenderer.symbols.filter((d) => d !== this.name);
      this.options = this.list
        .filter((d) => {
          let result = true;
          keys.forEach((e) => {
            if (
              (d[e] || d[e] === undefined) &&
              (PriceRenderer.getSymbol(e) > 0 ||
                PriceRenderer.getSymbol(e) === undefined) &&
              (parseFloat(d[e]) === PriceRenderer.getSymbol(e) ||
                PriceRenderer.getSymbol(e) === undefined ||
                d[e] === undefined)
            ) {
            } else {
              result = false;
            }
          });
          return result;
        })
        .map((d) => parseFloat(d[this.name]))
        .filter((d, i, a) => a.findIndex((item) => item === d) === i);
    }
    this.#dropdown?.setAttribute("options", this.options);
  }

  #handleInputBlur({ relatedTarget }) {
    if (relatedTarget !== this.#dropdown) {
      this.#dropdown?.removeAttribute("open");
    }
  }
  #handleDropdownChange({ detail: { value } }) {
    this.value = value;
    this.#dropdown?.removeAttribute("open");
  }

  #generateStyle() {
    return `
    * {
        box-sizing: border-box;
    }
    .w-full{
        width: 100%;
        position: relative;
    }
    .my-15 {
        margin-top: 1.5rem;
        margin-bottom: 1.5rem;
    }
    .flex-wrap {
        flex-wrap: wrap;
    }
    .flex {
        display: flex;
    }
    input {
        display:block;
        appearance: none;
        background-color: #fff;
        border: 1px solid #c7c7c7;
        border-radius: 3px;
        cursor: pointer;
        line-height: 1.25;
        padding: 0.75rem 1.5rem;
        color: #22292f;
        width: 100%;
        padding: 0.75rem 1.5rem 0.75rem 1.3rem;
        font-size: 1.5rem;
        font-weight: 400;
        background-image: url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTAgMWwxLTEgOCA4IDgtOCAxIDEtOSA5eiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+);
        background-position: right 1em center;
        background-size: 1em;
        background-repeat: no-repeat;
    }
    label  {
        display: block;
        font-weight: 500;
        margin-top: 0;
        position: relative;
        color: #101010;
        font-size: 1.3rem;
    }
    label span {
        display:block;
        margin-bottom: 0.5rem;
    }
    `;
  }
}

customElements.define("select-range", SeletRange);
